import type { SVGProps } from 'react'

export const GoogleDriveMonochromeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
    focusable={false}
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.332 15.337H9.23l-.05.088L6.596 20h11.77l.05-.089L21 15.341h-.299l-11.37-.004Zm6.31-1.089.05.086h.101L21 14.312l-.148-.26L15.115 4h-.102l-5.207.021.148.26 5.688 9.967ZM11.557 9.18l-.05-.089-2.622-4.55-.147.26L3 14.853l.05.089 2.622 4.553.148-.26 5.688-9.967.049-.089Z"
    />
  </svg>
)
